<p-inputGroup>
    <input
        pInputText
        class="w-full"
        [formControl]="viewModel().formControl"
        [placeholder]="viewModel().placeholder"
        [readonly]="viewModel().readonly"
        [required]="viewModel().required"
        [autofocus]="viewModel().autofocus"
        [type]="viewModel().type"
        [attr.data-testid]="viewModel().dataTestId"
    />
    <p-button
        icon="fa fa-clipboard"
        [disabled]="!viewModel().hasValue"
        (onClick)="copyToClipboard()"
        [pTooltip]="'common.copy-to-clipboard' | translate"
    />
</p-inputGroup>

